// Silueta común para integrantes sin foto. SVG inline para evitar dependencias externas.
export default function PersonSilhouette({ size = 40, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="ps-bg" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#cbd5e1" />
          <stop offset="100%" stopColor="#94a3b8" />
        </linearGradient>
      </defs>
      <rect width="100" height="100" fill="url(#ps-bg)" />
      {/* cabeza */}
      <circle cx="50" cy="38" r="18" fill="#f1f5f9" />
      {/* torso */}
      <path
        d="M16 100 C 16 76, 30 64, 50 64 C 70 64, 84 76, 84 100 Z"
        fill="#f1f5f9"
      />
    </svg>
  );
}
